import { AssessmentPlatformConfig } from "@/store/types";

export default window.$ASSESSMENT_PLATFORM_CONFIG as AssessmentPlatformConfig;
